import OrangeTheme, { ThemeContext } from 'main/theme/OrangeTheme';
import type { Config } from 'server/types';

export function initTheme(config: Config, context?: ThemeContext) {
    const theme = OrangeTheme(config, context);

    return theme;
}
